/**
 * The shooting range, as the menu sees it.
 *
 * Copy and a loader, and nothing else. Every static import here lands in the chunk that draws the
 * main menu, so this file reaches only `@/sim/weapons`, which is data: five gun files with no
 * geometry in them. The scene, the sim and the UI arrive through `load`, on the press that asks
 * for them.
 */

import { WEAPON_ORDER } from '@/sim/weapons/gunRegistry';
import type { GameMode, ModeCode } from '@/modes/modeContract';

export const SHOOTING_RANGE: GameMode = {
  id: 'shootingRange',
  title: 'Shooting range',
  tagline: 'Steel plates, live guns, no clock unless you start one',
  facts: [
    { label: 'Guns', value: String(WEAPON_ORDER.length) },
    { label: 'Players', value: '1 to 4' },
  ],
  controls: ['pointerLock', 'touch'],
  party: 'coop',
  hasBackdrop: true,
  /**
   * Both halves in one fetch, because the backdrop is this mode's own scene and the menu drawing it
   * is the strongest signal there is that this mode is about to be played. What the menu spends on
   * scenery is what the press on Play then does not have to.
   */
  async load(): Promise<ModeCode> {
    const [app, backdrop] = await Promise.all([
      import('@/modes/shootingRange/rangeApp'),
      import('@/modes/shootingRange/render/rangeBackdrop'),
    ]);
    return { launch: app.startShootingRange, createBackdrop: backdrop.createRangeBackdrop };
  },
};
